// Generic imports
import React from "react"

// Other components imports
import Button from "../Button"
import Image from "../../image"
import { Styles } from "./style"

// Redux imports

// Static imports

// Utils imports

const Modal = ({
  title,
  body,
  visible,
  btnText,
  btnClicked,
  close,
  closeBackground,
}) => {
  if (!visible) return <></>
  return (
    <Styles>
      <div className="background" onClick={closeBackground}></div>
      <div className="success-modal">
        {title && <div className="title">{title}</div>}
        {close && (
          <div onClick={close}>
            <Image
              style={{
                position: "absolute",
                right: "25px",
                top: "8px",
                marginBottom: "15px",
                marginTop: "15px",
                width: "10px",
                cursor: "pointer",
              }}
              imgName="close.png"
              alt="close"
              className="close"
            />
          </div>
        )}

        <div className="">{body}</div>
        {btnText && <Button onClick={btnClicked}>{btnText}</Button>}
      </div>
    </Styles>
  )
}

export default Modal
